import React ,{useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/styles';

import { Page } from 'components';
import {
  Header,
  EarningsSegmentation,
  FinancialStats,
  MostProfitableProducts,
  Overview,
  TopReferrals,
  CustomerActivity,
  LatestOrders
} from './components';
import CircularProgress from '@material-ui/core/CircularProgress';
import Api from '../Helpers/ApiHandler';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Grid } from '@material-ui/core';
var api = new Api();

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  container: {
    '& > *': {
      height: '100%'
    }
  }
}));

const DashboardAnalytics = () => {
  const classes = useStyles();
  const [dashboard, setDashboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sessionMessage, setSessionMessage] = useState({ message: "", type: "", open: false })
  const handleClose = (event, reason) => {
    setSessionMessage({ message: "", type: "", open: false })
  };


  useEffect(() => {
    let mounted = true;
    const fetchCustomers = () => {
      api.get('admin/dashboard').then(result => {
        setDashboard(result.data);
        setLoading(false);
      }).catch((err) => {
        setSessionMessage({ message: "there is something error", type: "error", open: true })
      })
    };

    fetchCustomers();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Page
      className={classes.root}
      title="Dashboard"
    >
      <Header  />
      <Grid
        className={classes.container}
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
        >
          <Overview dashboard={dashboard ? dashboard : ""} />
        </Grid>
        <Grid
          item
          lg={8}
          xl={9}
          xs={12}
        >
          {/* <FinancialStats /> */}
        </Grid>
        <Grid
          item
          lg={4}
          xl={3}
          xs={12}
        >
          {/* <EarningsSegmentation /> */}
        </Grid>
        <Grid
          item
          lg={12}
          xs={12}
        >
          <LatestOrders orders={dashboard.orders}/>
        </Grid>
        <Grid
          item
          lg={12}
          xs={12}
        >
          {/* <MostProfitableProducts products={dashboard.catalogs ? dashboard.catalogs.rows : ""}/> */}
        </Grid>
       
      </Grid>
    </Page>
  );
};

export default DashboardAnalytics;
